import { MessageCircle } from 'lucide-react';
import { Placeholder } from '@/shared/ui/primitives';
import styles from './EnvUnsupported.module.css';

export function EnvUnsupported() {
  return (
    <main className={styles.container}>
      <Placeholder
        title="Open Shanti in Telegram"
        description="Launch Shanti from its Telegram bot. If you are already in Telegram, update the app and try opening Shanti again."
      >
        <span className={styles.icon}>
          <MessageCircle size={36} aria-hidden="true" />
        </span>
      </Placeholder>
    </main>
  );
}
